import {DateFormatEnum} from 'presentation/constants';
import {formatDateString} from 'presentation/utils';

export function formatRefundDate(date: string) {
	const formatted = formatDateString(
		date,
		DateFormatEnum.DATE_FORMAT_4,
		DateFormatEnum.DATE_FORMAT_8,
	);

	return formatted;
}
